import { AppSettings } from '../../appsettings';

export const convertDecimalDelimiter = (value: number) => {
    const delimiter = AppSettings.get('decimalDelimiter');
    return value.toString().replace(/[,.]/g, delimiter);
};
